import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Root, AuthProvider } from '@components/custom'
import configureMaterialTheme from '@theme/material'
import { MuiThemeProvider } from '@material-ui/core/styles'
import configureStore from '@engine/store'
import { defaultKeycloak } from '@engine/enhancers'
import 'font-awesome/css/font-awesome.min.css'

const store = configureStore()

ReactDOM.render(
  <MuiThemeProvider theme={configureMaterialTheme()}>
    <Provider store={store}>
      <AuthProvider keycloak={defaultKeycloak}>
        <Root />
      </AuthProvider>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById('root')
)
